import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconSERPChecker(rest) {
  return (
    <Icon viewBox="0 0 32 32" {...rest}>
      <g fillRule="evenodd" fill="currentColor" clipRule="evenodd">
        <path d="m17 19h9v1h-9z" />
        <path d="m17 21h9v1h-9z" />
        <path d="m22 5h1v1h-1z" />
        <path d="m25 5h1v1h-1z" />
      </g>
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1}
      >
        <path d="m3.5 3.5h25v4h-25z" />
        <rect height="3" rx="1.5" width="19" x="6.5" y="11.5" />
        <path d="m3.5 3.5h25v25h-25z" />
        <path d="m6.5 18.5h8v7h-8z" />
      </g>
    </Icon>
  )
}
